export const navigationData = [
  {
    id: 1,
    name: 'Inicio',
    toScroll: 'IndexSection',
    offset: -120,
    duration: 500
  },
  {
    id: 2,
    name: 'Nosotros',
    toScroll: 'AboutSectionScroll',
    offset: -120,
    duration: 500
  },
  {
    id: 3,
    name: 'Propiedades',
    toScroll: 'PropertiesSectionScroll',
    offset: -120,
    duration: 500
  }, 
  {
    id: 4,
    name: 'Contáctanos',
    toScroll: 'ContactSectionScroll',
    offset: -120,
    duration: 500
  },
  {
    id: 5,
    name: 'Mi cuenta',
    toScroll: 'https://unne.prop360.cl/',
    offset: -120,
    duration: 500
  },
  // {
  //   id: 6,
  //   name: 'Detalle propiedad',
  //   href: '/Propiedades/:id',
  // }, 
];
